import request from '@/plugin/axios'

export function CreateQuery (data) {
  return request({
    url: '/query/create',
    method: 'post',
    data
  })
}

export function GetAssistItems () {
  return request({
    url: '/query/assist-items',
    method: 'get'
  })
}

export function ListDomainVariables (id) {
  return request({
    url: '/query/list-vars?id=' + id,
    method: 'get'
  })
}

export function ListQuerys (data) {
  return request({
    url: '/query/index',
    method: 'get',
    params: data
  })
}

export function CloseQuery (id) {
  return request({
    url: '/query/close?id=' + id,
    method: 'post'
  })
}

export function AnswerQuery (data) {
  return request({
    url: '/query/answer?id=' + data.id,
    method: 'post',
    data
  })
}

export function ViewDomainData (data) {
  return request({
    url: '/form-state/show-domain',
    method: 'get',
    params: data
  })
}
